import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  MunicipalitiesFilter,
  MunicipalityDetails,
} from '../../features/municipalities/municipalitiesSlice';

export function fetchMunicipalities(
  municipalitiesFilter: MunicipalitiesFilter,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: municipalitiesFilter,
  };

  return axios
    .get('/location/municipalities/getmunicipalities', config)
    .then(res => res.data);
}

export function fetchMunicipalityDetails(municipalityId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { municipalityId },
  };

  return axios
    .get('/location/municipalities/getmunicipalitydetails', config)
    .then(res => res.data);
}

export function addMunicipality(municipalityData: MunicipalityDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/location/municipalities/addmunicipality', municipalityData, config)
    .then(res => res.data);
}

export function updateMunicipality(municipalityData: MunicipalityDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/location/municipalities/updatemunicipality',
      municipalityData,
      config,
    )
    .then(res => res.data);
}

export function deleteMunicipality(municipalityId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { municipalityId },
  };

  return axios
    .delete('/location/municipalities/deletemunicipality', config)
    .then(res => res.data);
}
